export default __webpack_public_path__ + "static/media/Insider_Trading_Policy_1.c868c7f5.pdf";